import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
/**
 * フォームの情報
 */
const infoHeadTitleList: any[] = [
  {
    headTitle: "選択",
  },
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設所在地",
  },
  {
    headTitle: "ステータス",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050019_01,
  },
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050019_02,
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "取下げ日",
    keyword: "cancelDate",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    requiredIcon: true,
    type: "date",
  },
  {
    keyword: "facilityList",
    type: "node",
  },
];

const schema = {
  cancelDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

export { infoHeadTitleList, fakeTableList, schema };
